"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interactive = exports.colors = void 0;
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
exports.colors = {
    neutral: {
        resting: '#4F4E4C',
        hovered: '#333231',
        pressed: '#242423',
    },
    prominent: {
        resting: '#006CCF',
        hovered: '#024D95',
        pressed: '#15325D',
    },
    negative: {
        resting: '#C04226',
        hovered: '#88311E',
        pressed: '#562317',
    },
};
const Interactive = ({ appearance = 'neutral', children, ...props }) => {
    return (react_1.default.createElement(Base_1.Base, { color: exports.colors[appearance]['resting'], _hover: { color: exports.colors[appearance]['hovered'] }, _active: { color: exports.colors[appearance]['pressed'] }, transition: '300ms ease-out', ...props }, children));
};
exports.Interactive = Interactive;
